var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12186 -7672)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    transform: "translate(12186 7672)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11692.693 7662.563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.621,760.527q-.187,0-.374-.013a5.276,5.276,0,0,1-3.847-2.1.75.75,0,0,1,1.2-.9,3.744,3.744,0,0,0,1.213,1.052,3.778,3.778,0,0,0,3.13.224,3.756,3.756,0,0,0,1.351-.868l2.711-2.711a3.776,3.776,0,0,0-5.34-5.338l-1.553,1.544a.75.75,0,1,1-1.058-1.064l1.557-1.548.008-.008a5.276,5.276,0,0,1,7.46,7.46l-.009.009-2.715,2.715a5.246,5.246,0,0,1-1.887,1.213A5.315,5.315,0,0,1,445.621,760.527Z",
    transform: "translate(62.497 -734.37)",
    fill: "#313b5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.585,767.456h-.049a5.276,5.276,0,0,1-3.749-8.94l.009-.009,2.715-2.715a5.275,5.275,0,0,1,7.956.57.75.75,0,0,1-1.2.9,3.8,3.8,0,0,0-1.213-1.052,3.776,3.776,0,0,0-4.481.644l-2.711,2.711A3.776,3.776,0,0,0,441.2,764.9l1.543-1.543a.75.75,0,0,1,1.061,1.061l-1.548,1.548-.009.009A5.242,5.242,0,0,1,438.585,767.456Z",
    transform: "translate(63.25 -735.027)",
    fill: "#313b5c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkCopy);
export default __webpack_public_path__ + "static/media/link_copy.0fe25354b1538ccbf3fa8a3ed4444355.svg";
export { ForwardRef as ReactComponent };